import { type CurrencyName } from './CurrencyName'

export interface CurrencyConstructor {
  id: number
  name: CurrencyName
  rate: number
  base?: boolean
}

export class Currency {
  id: number
  name: CurrencyName
  rate: number
  base?: boolean

  constructor(data: CurrencyConstructor) {
    this.id = data.id
    this.name = data.name
    this.rate = data.rate
    this.base = data.base
  }
}
